import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { addRim, fetchRim, fetchRimList } from '../../../../store/details/rim/actions';

import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import DaccaButton from '../../../custom/dacca-button';
import { Dispatch } from 'redux';
import { ReportTypeTC } from '../../../../business/models/typecode.enums';
import { RimTotal, TabDetails } from '../../../../store/details/rim/types';
import { RimViews } from '../../../../store/details/rim/model';
import { connect } from 'react-redux';
import styles from './rim-list.module.css';
import { Role } from '../../../../store/shared/model';

interface PropsFromDispatch {
  readonly fetchRim: typeof fetchRim;
  readonly fetchRimsTotal: typeof fetchRimList;
  readonly addRim: typeof addRim;
}

interface PropsFromState {
  readonly data: RimTotal[];
  readonly currentRimId: number;
  readonly itemsTabs: { [key: string]: TabDetails };
  readonly rimBLocked: boolean;
  readonly instructionId: number;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class RimList extends React.Component<AllProps> {
  addRim(): void {
    this.props.addRim();
    this.props.fetchRimsTotal(this.props.instructionId);
  }

  render() {
    const isSelectedItem = (item: RimTotal) => item.rimHeaderId === this.props.currentRimId;
    const isLockedItem = (item: RimTotal) => item.locked ||  this.props.rimBLocked === true;

    const getBorderClass = (item: RimTotal) => {
      if (isSelectedItem(item)) {
        return styles.borderActive;
      }
      if (isLockedItem(item)) {
        return styles.borderLocked;
      }
      return styles.border;
    };

    const getBackroundClass = (item: RimTotal) => {
      if (isLockedItem(item)) {
        return styles.backgroundLocked;
      }
      return '';
    };

    const getTabIndicatorRowBodyClass = (item: RimTotal, view: RimViews) => {
      if (!this.props.itemsTabs[`${item.rimHeaderId}`]) { return styles.tabIndicatorRowBodyGreen; }
      const isTabSaved = this.props.itemsTabs[`${item.rimHeaderId}`][view].isSaved;

      if (!isTabSaved) { return styles.tabIndicatorRowBodyRed; }

      return styles.tabIndicatorRowBodyGreen;
    };

    const itemList = this.props.data.map(item => {
      return (
        <div key={item.rimHeaderId} className={`${styles.item} ${getBorderClass(item)} ${getBackroundClass(item)}`} onClick={() => {
          this.props.fetchRim(item.rimHeaderId);
        }}>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>{item.rimHeaderId}</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.valueAndCause)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.rimLines)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.vatAndPayment)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.counterExpertise)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.remark)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.communication)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorRow}>
            <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
            <div className={getTabIndicatorRowBodyClass(item, RimViews.signing)}>&nbsp;</div>
          </div>
          <div className={styles.tabIndicatorTotalRow}>
            <BelfiusCurrencyText
              value={item.totalAmount ? item.totalAmount : 0}
              prefix=' €' />
          </div>
        </div>
      );
    }
    );


    return (
      <div className={styles.container}>
        <div className={styles.itemRow}>
          {itemList}
        </div>
        <div className={styles.buttonContainer}>
        <DaccaButton
          {...this.props}
          reportType={ReportTypeTC.Rim}
          />
        <div className={styles.addButton}
             onClick={() => {
                if (this.props.rimBLocked) { return; }
                this.addRim(); }}>
          <img src={require('../../../../assets/images/add_85x85.png')} alt="" />
        </div>
        </div>
      </div >
    );
  }
}

const mapStateToProps = ({ details: { detailsRim }, caseState : { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  data: detailsRim.rimsTotal,
  currentRimId: detailsRim.rimHeaderId,
  itemsTabs: detailsRim.rimTotalItemsTabs,
  rimBLocked: selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
  instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRim: (id: number) => dispatch(fetchRim(id)),
  fetchRimsTotal: (instructionId: number) => dispatch(fetchRimList(instructionId)),
  addRim: () => dispatch(addRim())
});

export default connect(mapStateToProps, mapDispatchToProps)(RimList);
